import { Injectable } from '@angular/core';
import { FullStoryService } from '../fullstory/fullstory.service';
import { TelemetryData } from './telemetry.interface';
import { environment } from '@env/environment';
import { CapacitorService } from '../capacitor/capacitor.service';
import { FeatureFlagService } from '../feature-flag/feature-flag.service';
import { FeatureFlagName } from '../feature-flag/feature-flag.interface';

@Injectable({ providedIn: 'root' })
export class TelemetryService {
  constructor(
    private capacitorService: CapacitorService,
    private fullStoryService: FullStoryService,
    private featureFlagService: FeatureFlagService,
  ) {}

  initialize() {
    this.initializeFullStory();
  }

  identify(data: TelemetryData) {
    this.identifyFullStory(data);
  }

  anonymize() {
    this.fullStoryService.removeIdentity();
  }

  private initializeFullStory() {
    // FullStory is initialized natively on mobile
    if (this.capacitorService.isWeb()) {
      this.fullStoryService.initialize({
        orgId: 'o-1VTW5S-na1',
        devMode: environment.envName === 'local',
      });
    }
  }

  private identifyFullStory(data: TelemetryData) {
    if (this.featureFlagService.isFeatureOn(FeatureFlagName.fullstory)) {
      this.fullStoryService.setIdentity({
        uid: data.username,
        properties: {
          displayName: `${data.firstName} ${data.lastName}`,
          email: data.email,
          account_name: data.accountName,
          department_filtered: data.isDepartmentFiltered,
          wage_access: data.hasWageAccess,
          HE_hotel_admin: data.isHotelAdmin,
          job_title: data.jobTitle,
          user_type: data.userType,
          hotel_suspension_status: data.hotelSuspensionStatus,
          permissions: data.permissions,
          HE_app_name: 'Hotel Effectiveness App',
        },
      });
    }
  }
}
